import { Status } from '../../../../types/redux/data/dataTypes';
import {
  NavReconPositionThresholdPair,
  NavReconPositionThresholds,
} from '../../../../api/rs-hg/nav-recon/types';

export type NavReconGapThresholds = {
  alert_threshold: number;
  fail_threshold: number;
};

type NavReconPnLThresholdPair = NavReconPositionThresholds['p_and_l_threshold'];

export const toNavReconGapThresholds = (
  pair?: NavReconPositionThresholdPair | NavReconPnLThresholdPair,
): NavReconGapThresholds => {
  if (!pair) {
    return { alert_threshold: Infinity, fail_threshold: Infinity };
  }

  if ('alert' in pair) {
    return {
      alert_threshold: pair.alert,
      fail_threshold: pair.fail,
    };
  }

  return {
    alert_threshold: pair.lower_threshold,
    fail_threshold: pair.upper_threshold,
  };
};

export const toNavReconPositionSizeChangeGapThresholds = (
  threshold?: number,
): NavReconGapThresholds => {
  if (threshold == null || Number.isNaN(threshold)) {
    return { alert_threshold: Infinity, fail_threshold: Infinity };
  }

  return {
    alert_threshold: threshold,
    fail_threshold: Infinity,
  };
};

export const NAV_RECON_NO_POSITION_THRESHOLDS = {
  p_and_l_threshold: { alert: Infinity, fail: Infinity },
  position_size_change_threshold: Infinity,
  price_variation_threshold: {
    lower_threshold: Infinity,
    upper_threshold: Infinity,
  },
} as const;

/** Maps a gap/diff percentage to Pass, Alert, or Fail using absolute value vs thresholds. */
export const getNavReconGapStatus = (
  value: number | null | undefined,
  thresholds: NavReconGapThresholds,
): Status | null => {
  if (value == null || Number.isNaN(value)) return null;

  const absValue = Math.abs(value);
  if (absValue >= thresholds.fail_threshold) return Status.Fail;
  if (absValue >= thresholds.alert_threshold) return Status.Alert;
  return Status.Pass;
};
